<form-field-label [bold]="false" [labelTranslateKey]="'due_date'"></form-field-label>

<mat-form-field appearance="outline" class="deadline-container">
	<input
		matInput
		type="text"
		[min]="minDate"
		[matDatepicker]="picker"
		[formControl]="deadlineForm"
		placeholder="DD.MM.ÅÅÅÅ"
		(dateChange)="onDateChange($event.value)"
	/>
	<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
	<mat-datepicker #picker></mat-datepicker>
</mat-form-field>
